import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, SearchX } from "lucide-react";
import api from "@/lib/api";
import { ContentCard } from "@/components/ContentCard";
import { useAuth } from "@/context/AuthContext";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { kids } = useAuth();

  useEffect(() => {
    if (!q) { setItems([]); setLoading(false); return; }
    setLoading(true);
    api.get("/search", { params: { q, kids } }).then(({ data }) => setItems(data.items)).catch(() => setItems([])).finally(() => setLoading(false));
  }, [q, kids]);

  return (
    <div className="pt-24 px-4 sm:px-8 lg:px-12 pb-20 min-h-screen" data-testid="search-page">
      <h1 className="font-head text-2xl sm:text-3xl font-bold mb-6">
        Results for “<span className="text-brand">{q}</span>”
      </h1>
      {loading ? (
        <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-brand" size={36} /></div>
      ) : items.length === 0 ? (
        <div className="grid place-items-center py-20 text-center text-zinc-400">
          <SearchX size={48} className="mb-4" />
          <p>No titles found. Try another search — or ask an admin to research new streams.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((it) => <ContentCard key={it.id} item={it} />)}
        </div>
      )}
    </div>
  );
}
